/**
 * @generated SignedSource<<ab696a271ca0ac62165cfc11f1307c9c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountUpdateInput = {
  externalRef?: string | null;
  name?: string | null;
  addressLineOne?: string | null;
  addressLineTwo?: string | null;
  city?: string | null;
  state?: string | null;
  countryId?: string | null;
  zip?: string | null;
  website?: string | null;
  urls?: any | null;
  description?: string | null;
  phone?: string | null;
  businessLogoUrls?: any | null;
  coverPhotoUrls?: any | null;
  platformAccess?: any | null;
  paypalDetails?: any | null;
  stripeDetails?: any | null;
  stripeRef?: string | null;
  inviteLinkToken?: string | null;
  inviteLinkActive?: any | null;
  hubspotId?: string | null;
  authAllowEmail?: boolean | null;
  authPreferredType?: string | null;
  authName?: string | null;
  authDomain?: string | null;
  unmindOrganisationId?: string | null;
  isDemo?: any | null;
};
export type accountUpdateMutation$variables = {
  id: string;
  input: AccountUpdateInput;
};
export type accountUpdateMutation$data = {
  readonly updateAccount: {
    readonly account: {
      readonly " $fragmentSpreads": FragmentRefs<"accountBaseInlineFragment" | "accountAddressFragment" | "accountDetailsFragment" | "accountFinancialFragment">;
    };
  };
};
export type accountUpdateMutation = {
  variables: accountUpdateMutation$variables;
  response: accountUpdateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platformAccess",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountPayload",
        "kind": "LinkedField",
        "name": "updateAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "kind": "InlineDataFragmentSpread",
                "name": "accountBaseInlineFragment",
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountAddressFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountDetailsFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "accountFinancialFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountPayload",
        "kind": "LinkedField",
        "name": "updateAccount",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLineOne",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLineTwo",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zip",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "website",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urls",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "businessLogoUrls",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "coverPhotoUrls",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paypalDetails",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stripeDetails",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stripeRef",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "83e7a563cba01e8e278d9dceff894c77",
    "id": null,
    "metadata": {},
    "name": "accountUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation accountUpdateMutation(\n  $id: ID!\n  $input: AccountUpdateInput!\n) {\n  updateAccount(id: $id, input: $input) {\n    account {\n      ...accountBaseInlineFragment\n      ...accountAddressFragment\n      ...accountDetailsFragment\n      ...accountFinancialFragment\n      id\n    }\n  }\n}\n\nfragment accountAddressFragment on Account {\n  addressLineOne\n  addressLineTwo\n  city\n  state\n  countryId\n  zip\n}\n\nfragment accountBaseInlineFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment accountDetailsFragment on Account {\n  website\n  urls\n  description\n  phone\n  businessLogoUrls\n  coverPhotoUrls\n}\n\nfragment accountFinancialFragment on Account {\n  paypalDetails\n  stripeDetails\n  stripeRef\n}\n"
  }
};
})();

(node as any).hash = "c8800209c10e227fd8c41a5c95d6368d";

export default node;
